import { isAuthError, isForbiddenError } from '@/context/services/type';
import { useCallback } from 'react';
import type { CheckPermissionFn } from '../type';

export type { CheckPermissionFn };

function isForbiddenResult(result: unknown): boolean {
  if (result === null || typeof result !== 'object') return false;
  if (!('data' in result)) return false;
  const data = result.data;
  if (data === null || typeof data !== 'object') return false;
  if (!('status' in data) || typeof data.status !== 'number') return false;
  return !!(isAuthError(data.status) || isForbiddenError(data.status));
}

export const useCheckProtectedResources = () => {
  const handleCheckPermission = useCallback(
    async ({
      fnCheckPermission,
      onCheckSuccess,
      onCheckFailure,
    }: {
      fnCheckPermission?: () => void | Promise<unknown>;
      onCheckSuccess: () => void;
      onCheckFailure: () => void;
    }) => {
      try {
        if (!fnCheckPermission) return;
        const result = await fnCheckPermission();
        if (isForbiddenResult(result)) {
          onCheckFailure();
        } else {
          onCheckSuccess();
        }
      } catch {
        onCheckFailure();
      }
    },
    []
  );

  return { handleCheckPermission };
};
